import { useCallback, useMemo } from 'react';
import {
	ToothPathology,
	ToothPathologyDevelopmentDisorderValues,
	ToothSurface,
} from '../../../../../graphql/graphql';
import { SurfaceOperation } from '../../../Enums/SurfaceOperation.enum';
import { handleSurfacesOperation } from '../../../Helpers/surfaces/toothSurfaces.helper';

export default function useToothPathologyDevelopmentDisorder({
	pathology,
	setPathology,
}: {
	pathology?: ToothPathology;
	setPathology: (pathology: ToothPathology) => void;
}) {
	const setSurfaces = useCallback(
		(surfaces: ToothSurface[], operation: SurfaceOperation) => {
			setPathology({
				...pathology,
				developmentDisorder: {
					...pathology?.developmentDisorder,
					values: pathology?.developmentDisorder?.values ?? {},
					surfaces: handleSurfacesOperation(
						pathology?.developmentDisorder?.surfaces ?? [],
						surfaces,
						operation,
					),
				},
			});
		},
		[pathology, setPathology],
	);

	const setValues = useCallback(
		(values: ToothPathologyDevelopmentDisorderValues) => {
			setPathology({
				...pathology,
				developmentDisorder: {
					...pathology?.developmentDisorder,
					surfaces: pathology?.developmentDisorder?.surfaces ?? [],
					values,
				},
			});
		},
		[pathology, setPathology],
	);

	return useMemo(
		() => ({
			developmentDisorder: {
				surfaces: pathology?.developmentDisorder?.surfaces ?? [],
				setSurfaces: setSurfaces,
				values: pathology?.developmentDisorder?.values,
				setValues: setValues,
			},
		}),
		[pathology],
	);
}
